import React, { useCallback, useEffect, useState } from "react";
import { useHistory, useRouteMatch, Link } from "react-router-dom";
import { PlusOutlined } from "@ant-design/icons";

import { GET_USERS } from 'graphql/query/user-gql';

import Users from 'components/users';
import useUserCompanyFilter from 'components/users/hooks/use-user-company-filter';
import { errorNotification } from 'components/request-result';
import { useActiveMenuItem, useBreadCrumbs } from "components/use-hooks";
import { PageWrapDefault, Tables } from "components/layout";
import { Localize } from "components/service";
import { gqlBuilderWhere } from "utils";
import './users.scss';


const basePath = Users.Const.basePath;
const tableHelper = Users.Helpers.TableMain;
const emptyUsersModel = { data: [], paginatorInfo: { total: 0, perPage: 30 } };


const UsersPage = ({ canCreateUsers = false }) => {

    useActiveMenuItem(["users"], ["users"]);

    const breadcrumbs = [
        {
            label: Localize({ children: "BREADCRUMBS.Label_Users" }).props.children,
            path: `${basePath}`
        }
    ]

    useBreadCrumbs(breadcrumbs);

    const history = useHistory();
    const match = useRouteMatch(`${basePath}/page/:pageNum`);
    const currentPage = match ? parseInt(match.params.pageNum) : 1;

    const objOrderBy = [{ column: "ID", order: "DESC" }];

    const [searchText, setSearchText] = useState("");
    const [filters, setFilters] = useState();
    const [eventID, setEventID] = useState(undefined);
    const [resetSorting, setResetSorting] = useState(false);

    const usersFilters = JSON.parse(localStorage.getItem("usersFilters"));
    const usersFiltersEeID = JSON.parse(localStorage.getItem("usersFiltersEeID"));
    const usersSorting = JSON.parse(localStorage.getItem("usersSorting"));

    const { where, loading, error, retry } = useUserCompanyFilter(filters || gqlBuilderWhere(usersFilters));
    const lookupBlocked = loading || !!error;

    const resetPage = useCallback(() => {
        if (currentPage !== 1) history.push(basePath);
    }, [ currentPage, history ]);

    const applyFilters = useCallback(() => {
        retry();
        resetPage();
    }, [ retry, resetPage ]);

    useEffect(() => {
        if (error) errorNotification({ label: error.message || String(error), reason: "" });
    }, [ error ]);

    const pageNavbar = [
        {
            label: Localize({ children: "NAVBAR_PAGES.Label_Users" }).props.children,
            path: "users"
        },

        {
            label: Localize({ children: "NAVBAR_PAGES.Label_UserGroups" }).props.children,
            path: "user-groups"
        }];


    return (
        <PageWrapDefault
            className="page-users"
            dataExist={true}
            title={<Localize>PAGES.Title_Users</Localize>}
            pageNavbar={pageNavbar}
            staticPath=""
        >
            <Tables.Main
                model="users"
                query={GET_USERS}
                querySkip={lookupBlocked}
                externalModel={lookupBlocked ? emptyUsersModel : undefined}
                externalLoading={loading}
                tableVisible={!error}
                varSet={{ ee_id: eventID || usersFiltersEeID, perPage: 30 }}
                routeUrl={`${basePath}`}
                currentPage={currentPage}
                searchText={searchText}
                objFilter={where}
                objOrderBy={usersSorting || objOrderBy}
                sortingName="usersSorting"
                tableHelper={tableHelper}
                resetSorting={resetSorting}
            >
                <div className="table-action-bar">

                    <div className="col">
                        <Users.Filters.Table
                            filters={filters}
                            setSearchText={setSearchText}
                            setFilters={setFilters}
                            setEventID={setEventID}
                            eventID={eventID}
                            usersFilters={usersFilters}
                            usersFiltersEeID={usersFiltersEeID}
                            setResetSorting={setResetSorting}
                            objOrderBy={objOrderBy}
                            onApplyFilters={applyFilters}
                            onResetFilters={resetPage}
                        />
                    </div>

                    <div className="col">
                        {canCreateUsers &&
                            <Link
                                className="ant-btn ant-btn-primary"
                                to={`${basePath}/create`}>

                                <PlusOutlined /> <Localize>USER.Button_Text_Create</Localize>
                            </Link>
                        }
                    </div>
                </div>
            </Tables.Main>
        </PageWrapDefault>
    )
};

export default UsersPage;
